import React, {useCallback} from 'react';
import {useIntl} from 'react-intl';

import {useGeneralProvider} from 'brandComponents/_app-config/GeneralProvider';
import Button from 'brandComponents/Button';

import messages from './messages';

import styles from './AddToCartSuccessMsg.module.scss';

const AddToCartSuccessMsg = () => {
	const intl = useIntl();
	const {managerRepository} = useGeneralProvider();

	const onHandleOpenMinicartFlyout = useCallback(() => {
		managerRepository.getFlyoutsMgr().openFlyout('minicart', true);
	}, []);

	return (
		<div className={styles['success-message']}>
			{intl.formatMessage(messages.success, {
				comment: (chunk) => <span className={styles['success-message__added-to-cart']}>{chunk}</span>,
				cta: (chunk) =>
					<Button
						onClick={onHandleOpenMinicartFlyout}
						variant="tertiary"
						classNames={styles['success-message__view-btn']}
					>
						{chunk}
					</Button>,
			})}
		</div>
	);
};

export default AddToCartSuccessMsg;